import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Personal = () => {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-12 text-center">
          <h1 className="mb-4 text-primary">Personal Loans</h1>
          <p className="lead">
            Personal loans are unsecured loans that can be used for a variety of personal needs such as home renovation, medical expenses, weddings, travel, or debt consolidation.
          </p>
          <img 
            src="https://images.unsplash.com/photo-1605902711622-cfb43c44367f" 
            alt="Personal Loan" 
            className="img-fluid rounded shadow mb-4"
          />
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-success">Features of Personal Loans</h3>
          <ul className="list-group shadow">
            <li className="list-group-item">No collateral required</li>
            <li className="list-group-item">Quick approval and disbursal</li>
            <li className="list-group-item">Flexible repayment tenure (1 to 5 years)</li>
            <li className="list-group-item">Fixed interest rates</li>
            <li className="list-group-item">Used for multiple personal needs</li>
          </ul>
        </div>

        <div className="col-md-6">
          <h3 className="text-success">Benefits of Personal Loans</h3>
          <p>Personal loans provide instant access to funds without the need to pledge any asset. They are a great option for urgent financial needs.</p>
          <img 
            src="https://images.unsplash.com/photo-1588776814546-ec0a92ee6f74" 
            alt="Loan Benefits" 
            className="img-fluid rounded shadow"
          />
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-12">
          <h3 className="text-warning">Common Uses of Personal Loans</h3>
          <div className="card-deck d-flex flex-wrap gap-3">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">💍 Wedding Expenses</h5>
                <p className="card-text">Manage your wedding costs easily with flexible repayment options.</p>
              </div>
            </div>
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">🏥 Medical Emergencies</h5>
                <p className="card-text">Cover unexpected medical expenses without hassle.</p>
              </div>
            </div>
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">🛠️ Home Renovation</h5>
                <p className="card-text">Renovate your home the way you want with quick loan approvals.</p>
              </div>
            </div>
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">🌍 Travel & Vacation</h5>
                <p className="card-text">Make your dream vacation come true without financial stress.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-12">
          <h3 className="text-danger">Eligibility Criteria</h3>
          <ul className="list-group shadow">
            <li className="list-group-item">Minimum age: 21 years</li>
            <li className="list-group-item">Maximum age: 60 years</li>
            <li className="list-group-item">Salaried or self-employed individuals</li>
            <li className="list-group-item">Minimum income as per lender's policy</li>
            <li className="list-group-item">Good credit score preferred (650+)</li>
          </ul>
        </div>
      </div>

    </div>
  );
};

export default Personal;
